import * as React from 'react';
import { ModernSticky, OldSticky, SimpleSticky } from './components';
import { EStickyType } from './constants';
import { useStickyProps } from './useStickyProps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент-прилипалка с возможностью отслеживать события прилипания,
 * основанный на IntersectionObserver для современных браузеров
 * и на событиях scroll-resize для старых браузеров.
 * Для прилипания нужно задать onTopStuck и/или onBottomStuck
 * (в противном случае можно использовать обычный position:sticky )
 */

export var Sticky = function Sticky(props) {
  var children = props.children,
    zIndex = props.zIndex,
    onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck,
    topOffset = props.topOffset,
    bottomOffset = props.bottomOffset,
    testId = props.testId,
    position = props.position,
    intersectionOffset = props.intersectionOffset,
    root = props.root;
  var _useStickyProps = useStickyProps({
      onBottomStuck: onBottomStuck,
      onTopStuck: onTopStuck,
      topOffset: topOffset,
      bottomOffset: bottomOffset
    }),
    bottom = _useStickyProps.bottom,
    top = _useStickyProps.top,
    stickyType = _useStickyProps.stickyType;
  switch (stickyType) {
    case EStickyType.Simple:
      return /*#__PURE__*/_jsx(SimpleSticky, {
        testId: testId,
        zIndex: zIndex,
        bottom: bottom,
        top: top,
        position: position,
        intersectionOffset: intersectionOffset,
        children: children
      });
    case EStickyType.Modern:
      return /*#__PURE__*/_jsx(ModernSticky, {
        testId: testId,
        onBottomStuck: onBottomStuck,
        onTopStuck: onTopStuck,
        zIndex: zIndex,
        bottom: bottom,
        top: top,
        position: position,
        intersectionOffset: intersectionOffset,
        root: root,
        children: children
      });
    case EStickyType.Old:
      return /*#__PURE__*/_jsx(OldSticky, {
        testId: testId,
        onBottomStuck: onBottomStuck,
        onTopStuck: onTopStuck,
        zIndex: zIndex,
        bottom: bottom,
        top: top,
        position: position,
        intersectionOffset: intersectionOffset,
        root: root,
        children: children
      });
  }
};
Sticky.displayName = 'Sticky';